/* eslint-disable */
export default {
  participants: '참가자',
  host: '(호스트)',
  removeParticipant: '참가자 제거',
  removeTitle: '참가자 제거',
  removeDescription: '이 전화 회의에서 {name}님을 제거하시겠습니까?',
  confirmButtonText: '삭제',
  cancelButtonText: '취소',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
